export const MAX_PRODUCTS_HITS = 6
export const MAX_SUGGESTIONS_HITS = 5
export const IS_TYPING_DEBOUNCE_TIME = 300
export const SEARCH_BAR_INPUT_DATA_QA = 'search-bar-input'
